import { render, staticRenderFns } from "./PreviousAdmission.vue?vue&type=template&id=597883c2"
import script from "./PreviousAdmission.vue?vue&type=script&lang=js"
export * from "./PreviousAdmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports